var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConfirmPayroll(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#ED8B43;}\r\n\t.st1{fill:#FFCA69;}\r\n\t.st2{fill:#FF9B48;}\r\n\t.st3{fill:#FFD7B3;}\r\n\t.st4{fill:#FFFFFF;}\r\n\t.st5{fill:#58A9DE;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M275.4,145.7c0.1-0.1,0.2-0.1,0.3-0.2c1.3-1,1.5-2.8,0.5-4.1c-6.4-8.2-15.3-10.7-22.2-6.2l-0.3,0.2 c-2.1,1.4-6,4-10.8,3.4c-3.6-0.4-7.7-2.9-8.3-8.9c-0.2-1.6-1.6-2.8-3.2-2.6c-1.6,0.2-2.8,1.6-2.6,3.2c1,9.3,7.8,13.4,13.4,14 c6.9,0.8,12.1-2.7,14.6-4.3l0.2-0.2c5.2-3.4,11.1,0.5,14.5,4.9l0,0c-10-0.9-29.8,2.2-36.3,16.3c-0.7,1.5,0,3.2,1.4,3.8 c0.4,0.2,0.8,0.3,1.2,0.3c1.1,0,2.1-0.6,2.6-1.7c5.9-12.7,26.9-14,32.8-12.6c1.6,0.4,3.1-0.6,3.5-2.2 C277.1,147.6,276.5,146.3,275.4,145.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M324.1,148c2.2-0.1,4.1-1.4,5.1-3.6l13.5-29.8c2-4.4-0.8-9.6-5.2-9.6h-66.9c-4.4,0-7.2,5.2-5.2,9.6l13.5,29.8 c1,2.1,2.9,3.5,5.1,3.6c-48.8,14.4-85.6,78.6-85.6,129.6c0,57.8,47.3,76.8,105.7,76.8s105.7-19,105.7-76.8 C409.7,226.6,372.8,162.4,324.1,148z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M276.7,154.5h54.6c4.3,0,7.8-3.5,7.8-7.8l0,0c0-4.3-3.5-7.8-7.8-7.8h-54.6c-4.3,0-7.8,3.5-7.8,7.8l0,0 C268.9,151,272.4,154.5,276.7,154.5z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M173.2,383.3c0,5.8,4.7,10.5,10.5,10.5h143.1c2.8,0,5.5-0.9,7.7-2.5l95-69.2c6.5-4.8,7.1-14,1.3-19.6l-1-0.9 c-4.3-4.1-10.9-4.8-15.9-1.7l-68.5,42.2c-2.2,1.3-4.8,2-7.4,2l-60.8-2.2c-7.1-0.2-12.7-6.1-12.6-13.2l0.1-3.6 c0.2-7.2,6.3-12.8,13.5-12.5l50.6,0.8c7.5,0.2,13.7-4.6,13.5-12l-0.1-4.6c-0.2-7-6-12.5-13-12.5h-44.5c-3.1,0-6.2-1.1-8.5-3.1 l-8.2-4c-26.5-13.2-58.7-7.7-79.5,13.3l-11.3,11.3c-2.5,2.5-4,6-4,9.6V383.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M136.4,398.3h39c3.4,0,6.2-2.8,6.2-6.2v-92.3c0-3.4-2.8-6.2-6.2-6.2h-39c-3.4,0-6.2,2.8-6.2,6.2v92.3 C130.2,395.5,132.9,398.3,136.4,398.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M93.6,407h43.7c9,0,16.3-7.3,16.3-16.3v-89.4c0-9-7.3-16.3-16.3-16.3H93.6c-9,0-16.3,7.3-16.3,16.3v89.4 C77.2,399.7,84.5,407,93.6,407z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M329.9,215.4v-0.6c0-4.5-0.9-8.4-2.6-11.6c-1.7-3.2-4.2-5.6-7.5-7.3c-3.3-1.7-7.2-2.5-11.9-2.5 c-4.6,0-8.6,0.8-11.9,2.5c-3.3,1.7-5.8,4.1-7.5,7.3c-1.7,3.2-2.6,7-2.6,11.5v16.6h-6.6v7.6h6.6v9c0,2.9-0.6,5-1.9,6.5 s-3.1,2.2-5.5,2.2h-0.3v9.6h51.6v-9.6h-37.8c2.7-2,4-4.8,4-8.6v-9h21.5v-7.6h-21.5v-16.6c0-3.7,1-6.6,3.1-8.6c2.1-2,5-3.1,8.7-3.1 c3.7,0,6.6,1,8.7,3.1c2.1,2.1,3.1,5,3.1,8.7v0.6H329.9z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfirmPayroll);
export default __webpack_public_path__ + "static/media/confirmPayroll.8c30c71f1e39bce123743720dfcf646c.svg";
export { ForwardRef as ReactComponent };